import React, { Component } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { produce } from 'immer';

import { VerticalStackSettings } from '@paragon/contract-library';
import { DistanceField, NumericField } from '@paragon/material';

import { InteriorConditionSettingsPropertiesProps } from './InteriorConditionSettingsPropertiesProps';

type Props = InteriorConditionSettingsPropertiesProps<VerticalStackSettings>;

export class VerticalStackSettingsProperties extends Component<Props> {
  createSubmitHandler =
    <K extends keyof VerticalStackSettings>(key: K) =>
    (value: VerticalStackSettings[K]) => {
      this.props.onChange({ ...this.props.value, [key]: value });
    };

  defaultVerticalStack = () => {
    this.props.onChange(
      produce(this.props.value, (value) => {
        value.distanceFromLeft = 48;
        value.bearingWidth = 4.5;
        value.hasBearing = true;
        value.verticalsCount = 2;
      }),
    );
  };

  render() {
    const { value } = this.props;

    return (
      <Box style={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <DistanceField
            sx={[value.distanceFromLeft === 0 ? { m: 1, fieldSet: { borderColor: 'brand.orange' } } : { m: 1 }]}
            label="Distance From Left"
            value={value.distanceFromLeft}
            onSubmit={this.createSubmitHandler('distanceFromLeft')}
          />

          <DistanceField
            sx={{ m: 1 }}
            label="Bearing Width"
            value={value.bearingWidth}
            onSubmit={this.createSubmitHandler('bearingWidth')}
          />

          <NumericField
            sx={{ m: 1 }}
            label="Verticals Count"
            value={value.verticalsCount}
            onSubmit={this.createSubmitHandler('verticalsCount')}
          />
        </Box>
        <Box sx={{ display: 'flex', m: 1 }}>
          <FormControlLabel
            sx={{ m: 'auto' }}
            control={
              <Checkbox
                checked={value.hasBearing}
                onChange={(event) => this.createSubmitHandler('hasBearing')(event.target.checked)}
              />
            }
            label="Has Bearing"
          />
        </Box>
      </Box>
    );
  }
}
